import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Http, Response, Headers } from '@angular/http';
import { SharedService } from '../../shared/shared.service';
@Injectable()

export class segmentsService {
	public baseUrl: string; 
	constructor(private _http: Http, private _data: SharedService,) { 
		this.baseUrl = environment.apiUrl;
	}
	

	getSegments = async () => {
		try {
			const response = await fetch(this.baseUrl+'segments')
			const data = await response.json();
			return data
			} catch (error) {
			console.error(error);
			}
		}

	
	getSegmentById(data: any) {
		let json = JSON.stringify(data);
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + data.auth_token);

		return this._http.get(this.baseUrl + 'segments/' + data.Id, { headers: headers })
			.map(res => res.json());
	}



	updateSegment(data: any) {

			let headers = new Headers();
			headers.append('Content-Type', 'application/json');
			headers.append('Authorization', 'Bearer ' + data.auth_token);
			delete data.auth_token;
			let json = JSON.stringify(data);

			return this._http.put(this.baseUrl + 'segments/' , json, { headers: headers })
				.map(res => res.json());
		}

    newsSegments(data: any) {
		let json = JSON.stringify(data);
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');

		return this._http.post(this.baseUrl + 'segments', json, { headers: headers })
			.map(res => res.json());
	}


    getFiles1() {
        return this._http.get('assets/files.json')
			.toPromise()
			.then(res => res.json());
        }
    
    uploadfiles(file: any) {
        const headers = new Headers({});
        headers.append('Authorization', 'Bearer ' + this._data.getCookie('auth_token'));
        return this._http.post(this.baseUrl + 'segments/excel', file, { headers: headers }).map(res => res.json());
        }
        

}



// WEBPACK FOOTER //
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/admin/segments/segments.service.ts